app.controller("initCtrl", [
  "$scope",
  "$location",
  "$localStorage",
  "LocalStorageFactory",
  function ($scope, $location, $localStorage, LocalStorageFactory) {
    $scope.costSort = null;
    $scope.titleSort = null;

    $localStorage.siteID = fullSite.siteID;

    var siteConfig = fullSite;

    $scope.siteAvailable = siteConfig.siteAvailable;
    if (!siteConfig.siteAvailable) $location.path("/siteUnavailable");

    $scope.showContactus =
      siteConfig.contactPhone &&
      siteConfig.contactEmail &&
      siteConfig.contactAddress &&
      siteConfig.contactText;

    $scope.siteLogo = siteConfig.siteLogoURL;
    $scope.shopTitle = siteConfig.shopTitle;
    $scope.faviconURL = siteConfig.faviconURL;

    function change_favicon(img) {
      var favicon = document.querySelector('link[rel="shortcut icon"]');
      if (!favicon) {
        favicon = document.createElement("link");
        favicon.setAttribute("rel", "shortcut icon");
        var head = document.querySelector("head");
        head.appendChild(favicon);
      }
      favicon.setAttribute("type", "image/png");
      favicon.setAttribute("href", img);
    }
    change_favicon(siteConfig.faviconURL);

    //contacts
    $scope.showContacts = false;
    $scope.contactPhone = "";
    if (siteConfig.contactPhone) {
      $scope.contactPhone = siteConfig.contactPhone;
      $scope.showContacts = true;
    }

    $scope.contactEmail = "";
    if (siteConfig.contactEmail) {
      $scope.contactEmail = siteConfig.contactEmail;
      $scope.showContacts = true;
    }

    $scope.contactAddress = "";
    if (siteConfig.contactAddress) {
      $scope.contactAddress = siteConfig.contactAddress;
      $scope.showContacts = true;
    }

    var playlists = {
      heroLivePlaylistID: siteConfig.heroLivePlaylistID,
      featuredLivePlaylistID: siteConfig.featuredLivePlaylistID,
      mainLivePlaylistID: siteConfig.mainLivePlaylistID,
      heroOndemandPlaylistID: siteConfig.heroOndemandPlaylistID,
      featuredOndemandPlaylistID: siteConfig.featuredOndemandPlaylistID,
      mainOndemandPlaylistID: siteConfig.mainOndemandPlaylistID,
    };
    $localStorage.playlistIDs = JSON.stringify(playlists);

    if ($location.path() === "/") {
      if ($localStorage.redirect !== undefined) {
        let tempPath = $localStorage.redirect;
        LocalStorageFactory.remove("redirect");
        window.location.href = tempPath;
      } else {
        $location.path("/home");
      }
    }
  },
]);

app.controller("footerCtrl", [
  "$scope",
  "$localStorage",
  function ($scope, $localStorage) {
    $localStorage.siteID = siteID;

    var siteConfig = fullSite;

    if (siteConfig.siteAvailable == false) {
      $scope.siteAvailable = false;
    } else {
      $scope.siteAvailable = true;
    }

    $scope.footerTopColor =
      siteConfig.footerTopColor != "" ? siteConfig.footerTopColor : "white";
    $scope.footerBottomColor =
      siteConfig.footerBottomColor != ""
        ? siteConfig.footerBottomColor
        : "#212121";
    $scope.footerTextColor =
      siteConfig.footerTextColor != "" ? siteConfig.footerTextColor : "#333333";

    $scope.shopTitle = siteConfig.shopTitle;
    $scope.footerLogo = siteConfig.footerLogo;
    $scope.footerLogoURL = siteConfig.footerLogoURL;

    //contacts
    $scope.showContacts = false;

    $scope.contactPhone = "";
    if (
      siteConfig.contactPhone !== undefined &&
      siteConfig.contactPhone != null &&
      siteConfig.contactPhone !== ""
    ) {
      $scope.contactPhone = siteConfig.contactPhone;
      $scope.showContacts = true;
    }

    $scope.contactEmail = "";
    if (
      siteConfig.contactEmail !== undefined &&
      siteConfig.contactEmail != null &&
      siteConfig.contactEmail !== ""
    ) {
      $scope.contactEmail = siteConfig.contactEmail;
      $scope.showContacts = true;
    }

    $scope.contactAddress = "";
    if (
      siteConfig.contactAddress !== undefined &&
      siteConfig.contactAddress != null &&
      siteConfig.contactAddress !== ""
    ) {
      $scope.contactAddress = siteConfig.contactAddress;
      $scope.showContacts = true;
    }
  },
]);

app.controller("404Ctrl", [
  "$scope",
  "$localStorage",
  function ($scope, $localStorage) {
    let microsite = JSON.parse($localStorage.microsite);
    let siteConfig = microsite.microsite;
    let error_message = "The page you are looking for could not be found.";

    if (siteConfig.customErrorMessage != "--") {
      error_message = siteConfig.customErrorMessage;
    }
    $scope.error_404_message = error_message;
  },
]);

app.controller("siteErrorCtrl", [
  function () {
    $("#siteHeader").hide();
  },
]);

app.controller("customErrorCtrl", [
  "$scope",
  "$localStorage",
  function ($scope, $localStorage) {
    let microsite = JSON.parse($localStorage.microsite);
    let siteConfig = microsite.microsite;
    $scope.error_message = siteConfig.customErrorMessage;
  },
]);
